<template>
  <div class="outsiders">
    <div class="outsiders-content">
      <div class="top">
        <div class="canteen-name">
          <div class="canteen-title">食堂名称</div>
          <el-select v-model="canteen" placeholder="请选择" class="w200" clearable @change="change">
            <el-option
              v-for="item in canteenList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="outsiders-container">
        <div class="every-day" v-for="(item, index) in applyList" :key="index">
          <div class="apply-title">
            <div>
              <span class="apply-date">
                {{ item.date }}
              </span>
              <span class="today" v-if="index==0"> (今日) </span>
            </div>
            <div>就餐人数：{{ item.totalPeopleNum }}人</div>
          </div>
          <div class="apply-container" v-if="item.applicationList.length > 0">
            <div
              class="apply-content"
              v-for="(v, idx) in item.applicationList"
              :key="idx"
            >
              <div class="apply-name">第{{ idx+1 }}个申请单</div>
              <div class="apply-info">
                <span class="sub-title">经办人</span>
                <span class="sub-name">{{ v.userName }}</span>
              </div>
              <div class="apply-info">
                <span class="sub-title">就餐时间段</span>
                <span class="sub-name">{{ v.eatTime }}</span>
              </div>
              <div class="apply-info">
                <span class="sub-title">就餐人数</span>
                <span class="sub-name">{{ v.peopleNum }}</span>
              </div>
              <div class="apply-info apply-department">
                <span class="sub-title">经办人部门</span>
                <span class="sub-name">{{ v.deptName }}</span>
              </div>
            </div>
          </div>
          <div class="apply-container" v-else>
            <img class="apply-nothing" src="../../../../assets/nothing-add.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Outsiders from "@/models/outsiders.js";
import Canteen from "@/models/canteen.js";
export default {
  data() {
    return {
      canteen: "",
      canteenList: [],
      /* 申请集合 */
      applyList: [],
    };
  },

  created() {
    config()
    this.initCanteenList()
  },

  methods: {
    initCanteenList() {
      Canteen.getCanteenNoPageList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.canteenList = arr
          this.canteen = arr[0].id
          this.initApplyList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },
    
    initApplyList() {
      let canteenId = this.canteen;
      let data = {
        canteenId
      }
      Outsiders.getOutsidersList(data).then((res) => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.date = i.date
            obj.totalPeopleNum = i.totalPeopleNum
            obj.applicationList = []
            i.applicationList.map(v => {
              let obj2 = {}
              obj2.userName = v.userName
              obj2.peopleNum = v.peopleNum
              obj2.deptName = v.deptName
              obj2.eatTime = ''
              let breakfastVal = ''
              let lunchVal = ''
              let dinnerVal = ''
              if (v.breakfast) {
                breakfastVal = v.breakfast?'早餐':''
                obj2.eatTime = breakfastVal
              }
              if (v.lunch) {
                lunchVal =v.lunch?'午餐':''
                if (obj2.eatTime) {
                  obj2.eatTime += `、${lunchVal}`
                } else {
                  obj2.eatTime = `${lunchVal}`
                }
              }
              if (v.dinner) {
                dinnerVal = v.dinner?'晚餐':''
                if (obj2.eatTime) {
                  obj2.eatTime += `、${dinnerVal}`
                } else {
                  obj2.eatTime = `${dinnerVal}`
                }
              }
              obj.applicationList.push(obj2)
            })
            arr.push(obj)
          })
          this.applyList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    change() {
      if (this.canteen) {
        this.initApplyList();
      }
    }
  },
};
</script>

<style lang='scss'>
.outsiders {
  flex: 1;
  background: $bg-white;
  .top {
    @include flex-start;
    padding: 20px;
    .el-button {
      padding: 0px;
    }
    .canteen-name {
      @include flex-center;
      font-size: $fs-small-l;
      border: 1px solid $bg-ShallowLightSnow;
      .canteen-title {
        height: 32px;
        line-height: 32px;
        padding-left: 19px;
        font-weight: 400;
        color: $color-LightGrey;
      }
      .el-input__inner {
        border: none;
      }
    }
  }
  .outsiders-container {
    @include flex-start;
    flex-wrap: wrap;
    padding: 0px 20px 20px 20px;
    .every-day {
      width: 273px;
      height: 334px;
      border: 1px solid $bg-ShallowLightSnow;
      border-radius: 2px;
      margin: 0px 20px 20px 0px;
      .apply-title {
        height: 44px;
        background: $bg-ChangeDepartmentTree;
        @include flex-between;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        padding: 0px 19px;
        .apply-date,
        .today {
          font-size: $fs-medium-s;
          font-weight: bold;
          color: $color-BlackGrey;
        }
        .today {
          color: $color-PhoneStar;
        }
      }
      .apply-container {
        height: 290px;
        overflow-y: auto;
        @include scrollbarNotrack;
        position: relative;
        .apply-nothing {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 104px;
          height: 87px;
        }
      }
    }
    .apply-content {
      padding-top: 20px;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      .apply-name {
        margin-bottom: 12px;
      }
      .apply-info {
        span {
          width: 50%;
          display: inline-block;
          box-sizing: border-box;
          height: 32px;
          line-height: 32px;
        }
        .sub-title {
          text-align: right;
          padding-right: 20px;
          border-right: 2px dashed $bg-DeepReddishBlue;
          position: relative;
          &::after {
            position: absolute;
            top: 50%;
            right: -9px;
            width: 16px;
            height: 16px;
            transform: translateY(-50%);
            content: '';
            background: url('../../../../assets/circular.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
        .sub-name {
          text-align: left;
          padding-left: 20px;
        }
      }
    }
  }
}
</style>
